import { render } from "./avatar.html?vue&type=template&id=83ca4cea&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=ts"
export * from "./Avatar.vue?vue&type=script&lang=ts"

import "./avatar.scss?vue&type=style&index=0&id=83ca4cea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-83ca4cea"

export default script